import './Match.scss'
import React, { Component } from 'react'
import { Zoom, Slide, Fade } from '@material-ui/core'
import {
    Status,
    Video,
    Demo,
    ButtonArrow,
    Instruction,
    sdk,
    getBioDataFromVideo,
    getBioDataFromImageData
} from '@svort/component'
import {
    imageDataToBase64,
    drawScaledImage,
    isMobile
} from '../../utils/utils'
import axios from '../../utils/axios'
import { Translated } from '../../utils/translated'

import { ReactComponent as TakePhotoSVG } from './images/take_photo.svg'
import { ReactComponent as UploadPhotoSVG } from './images/upload_photo.svg'
import colors from '../../mixins.scss'

export class Match extends Component {

    constructor(props) {
        super(props);

        this.videoRef = React.createRef();
        this.canvasSampleRef = React.createRef();
        this.canvasClientRef = React.createRef();

        this.state = {
            isDemo: false,
            isMatch: false,

            isInit: false,
            isChoose: false,
            isTakePhoto: false,
            isPrepare: false,
            isScaning: false,
            isCompare: false,
            isChecking: false,

            isLoading: false,
            isSuccess: false,
            isError: false,
            status: '',
            onRetry: () =>
                this.setState({
                    isError: false,
                    isCompare: false,
                    isMatch: true,
                    isChoose: true,
                    maxSimilarity: null,
                    minSimilarity: null,
                    currentSimilarity: 'Calculating...',
                }),

            sample: null,

            currentSimilarity: 'Calculating...',
            maxSimilarity: null,
            minSimilarity: null
        }

        this.baseRadius = Math.max(window.outerHeight, window.innerHeight) * 0.45 / 2;
        this.isMobile = isMobile();
    }

    async componentDidMount() {
        this.checkSDKLoaded();
    }

    componentWillUnmount() {
        if (this.ws) {
            this.ws.close();
            console.log('match WS closed');
        }
    }

    checkSDKLoaded = () => {
        this.setState({
            isMatch: true,
            isLoading: true,
            isPureStatus: true,
            status: <Translated id="downloading_sdk" values={{ progress: 0 }} />
        }, async () => {
            const isLoaded = await sdk.isLoaded();
            if (isLoaded)
                this.setState({
                    isLoading: false,
                    isPureStatus: false,
                    isDemo: this.props.isDemo && this.props.isOnboarding,
                    isMatch: !this.props.isDemo,
                    isChoose: !this.props.isDemo
                })
            else sdk.setProgressListener((data) => {
                if (data.isLoaded)
                    this.setState({
                        isLoading: false,
                        isPureStatus: false,
                        isDemo: this.props.isDemo && this.props.isOnboarding,
                        isMatch: !this.props.isDemo,
                        isChoose: !this.props.isDemo
                    })
                else this.setState({
                    status: <Translated id="downloading_sdk" values={{ progress: (data.currentProgress * 100 / data.dataSize).toFixed(1) }} />
                })
            });
        });
    }

    onVideoCanPlay = () => {
        this.setState({
            isInit: false,
            isLoading: false,
            isPrepare: this.state.isTakePhoto
        }, () => {
            this.getPhoto()
        });
    }

    onVideoError = (error, message) => {
        console.log('video_error:', error, message);

        this.setState({
            isInit: false,
            isLoading: false,
            isTakePhoto: false,
            isCompare: false,
            isError: true,
            status: error,
            onRetry: () =>
                this.setState({
                    isError: false,
                    isInit: true,
                    isTakePhoto: true,
                    isLoading: true,
                    status: 'permission_request'
                })
        });
    }

    onDemo = () => {
        this.setState({
            isDemo: false,
            isMatch: true,
            isChoose: true,
            direction: 'right'
        });
    }

    onStartTakePhoto = () => {
        this.setState({
            isChoose: false,
            isLoading: true,
            isInit: true,
            isTakePhoto: true,
            status: 'permission_request'
        });
    }

    onTakePhoto = () => {
        this.setState({
            isScaning: false,
            isTakePhoto: false,
        }, () => {
            let imageData;
            if (this.props.isOnboarding) {
                const canvas = document.createElement('canvas');
                canvas.width = this.state.sample.width;
                canvas.height = this.state.sample.height;
                const context = canvas.getContext('2d');
                context.putImageData(this.state.sample, 0, 0);

                const canvasTemp = document.createElement('canvas');
                canvasTemp.width = this.state.sample.width;
                canvasTemp.height = this.state.sample.height;
                const contextTemp = canvasTemp.getContext('2d');

                contextTemp.scale(-1, 1);
                contextTemp.drawImage(canvas, 0, 0, canvas.width * -1, canvas.height);

                imageData = contextTemp.getImageData(0, 0, canvas.width, canvas.height);
            } else imageData = this.state.sample;

            this.analyzePhoto([imageData]);
        });
    }

    onUploadPhoto = async (photos) => {
        const images = await Promise.all([...photos].map(photo => new Promise(res => {
            var fr = new FileReader();
            fr.onload = () => {
                var img = new Image();
                img.onload = async () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = this.props.isOnboarding ? img.width : 640;
                    canvas.height = this.props.isOnboarding ? img.height : 480;

                    const context = canvas.getContext('2d');
                    drawScaledImage(img, context);
                    // document.body.appendChild(canvas);

                    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                    res(imageData);
                };
                img.src = fr.result;
            };
            fr.readAsDataURL(photo);
        })));

        this.setState({
            isChoose: false,
            sample: images[0]
        }, () => {
            this.analyzePhoto(images);
        });
    }

    async analyzePhoto(images) {
        this.setState({
            isLoading: true,
            status: this.props.isOnboarding ? 'app.matching.analyzing-doc' : 'app.matching.analyzing-photo'
        }, async () => {
            if (this.props.isOnboarding) {
                const photos = await Promise.all(images.map(imageData => new Promise(res => res(imageDataToBase64(imageData)))));
                this.props.onPassport(photos);
            } else {
                const imageData = images[0];
                const { bioData } = await getBioDataFromImageData(imageData);
                this.setState({
                    isLoading: false,
                    isSuccess: true
                }, () => setTimeout(() => {
                    this.setState({
                        isSuccess: false,
                        isInit: true,
                        isCompare: true
                    }, () => {
                        this.drawFace(imageData, this.canvasSampleRef.current, bioData ? bioData.faceRect : null);
                        this.getPhoto();
                    });
                }, 2000));
            }
        });
    }

    async drawFace(imageData, canvasClient, faceRect) {
        const canvas = document.createElement('canvas');
        canvas.width = imageData.width;
        canvas.height = imageData.height;
        const context = canvas.getContext('2d');
        context.putImageData(imageData, 0, 0);

        // const blob = await getCanvasBlob(canvas);
        // const photo = await blobToBase64(blob);
        // console.log(photo);

        context.beginPath();
        context.lineWidth = 5;
        context.strokeStyle = colors.svRed;

        if (!!faceRect) {
            context.rect(faceRect.x, faceRect.y, faceRect.w, faceRect.h);
            context.stroke();
        }

        const contextClient = canvasClient.getContext('2d');
        contextClient.clearRect(0, 0, contextClient.canvas.width, contextClient.canvas.height);

        drawScaledImage(canvas, contextClient);
    }

    async getPhoto() {
        const { imageData, bioData } = await getBioDataFromVideo(this.videoRef.current);

        if (bioData || this.props.isOnboarding) {
            if (this.state.isPrepare) {
                this.setState({
                    isPrepare: false,
                    isScaning: true
                });
            } else if (this.state.isScaning) {
                this.setState({
                    sample: imageData
                });
            } else if (this.state.isCompare) {
                this.drawFace(imageData, this.canvasClientRef.current, bioData.faceRect);

                const sample = await imageDataToBase64(this.state.sample);
                const photo = await imageDataToBase64(imageData);

                if (!this.state.isChecking) {
                    await this.setStateSync({ isChecking: true });
                    this.checkSimilarity(sample, photo);
                }
            }
        } else {
            // this.setState({
            //     isPrepare: true,
            //     isScaning: false
            // });
        }

        await new Promise((res) => setTimeout(() => res(), 10));
        if (!this.state.isError && !this.state.isLoading)
            this.getPhoto();
    }

    async checkSimilarity(sample, photo) {
        const response = await axios.post('check_matching', { sample, photo });
        const { status, message, similarity } = response;

        if (status === 'success') {
            const maxSimilarity = this.state.maxSimilarity ? Math.max(this.state.maxSimilarity, similarity) : similarity;
            const minSimilarity = this.state.minSimilarity ? Math.min(this.state.minSimilarity, similarity) : similarity;

            this.setState({
                currentSimilarity: similarity,
                maxSimilarity,
                minSimilarity,
            }, () => setTimeout(() => this.setState({ isChecking: false }), 1000));
        } else if (status === 'error' && message === 'face_not_found') {
            this.setState({ isChecking: false });
        } else if (status === 'error')
            this.setState({
                isChecking: false,
                isCompare: false,
                isError: true,
                status: `server_response_error_${message}`
            });
    }

    setStateSync(state) {
        return new Promise(res => this.setState(state, res));
    }

    render() {
        return (
            <div className='match-wrapper'>
                <Demo
                    isShow={this.state.isDemo}
                    demoType={'matching'}
                    onDemo={this.onDemo}
                    direction={this.state.direction || 'left'} />

                <Slide direction={this.props.direction || 'left'} in={this.state.isMatch} timeout={{ enter: 800, exit: 500 }} mountOnEnter unmountOnExit>
                    <div className='match'>

                        {!this.props.isOnboarding &&
                            <div className='header'>
                                <Translated id="app.matching.title" />
                            </div>}

                        <Slide in={this.state.isChoose} direction={this.props.direction || 'left'} timeout={{ enter: 500, exit: 0 }} mountOnEnter unmountOnExit>
                            <div className='choosing'>
                                <label htmlFor='take-photo'>
                                    <TakePhotoSVG onClick={() => !this.isMobile && this.onStartTakePhoto()} />
                                </label>
                                {this.isMobile &&
                                    <input
                                        id='take-photo'
                                        type='file'
                                        accept='image/*'
                                        capture='camera'
                                        onChange={(e) => this.onUploadPhoto(e.target.files)}
                                    />}

                                <Translated id="app.matching.or" />

                                <label htmlFor='upload-photo'>
                                    <UploadPhotoSVG />
                                </label>
                                <input
                                    id='upload-photo'
                                    type='file'
                                    accept='image/*, application/pdf'
                                    multiple={this.props.isOnboarding}
                                    onChange={(e) => this.onUploadPhoto(e.target.files)}
                                />
                            </div>
                        </Slide>

                        <Fade in={!this.state.isError && (this.state.isTakePhoto || this.state.isCompare)} timeout={{ enter: 500, exit: 0 }} mountOnEnter unmountOnExit>
                            <div className='take-photo' style={this.state.isCompare ? { position: 'absolute' } : null}>
                                <Video
                                    isInit={this.state.isInit}
                                    isShow={!this.state.isLoading && this.state.isTakePhoto}
                                    isSquare={this.state.isTakePhoto && !this.props.isOnboarding}
                                    isPattern={this.props.isOnboarding}
                                    videoRef={this.videoRef}
                                    baseRadius={this.baseRadius}
                                    borderRadius={'0'}

                                    onVideoCanPlay={this.onVideoCanPlay}
                                    onError={this.onVideoError} />

                                {!this.state.isLoading && this.state.isTakePhoto &&
                                    <button
                                        onClick={this.onTakePhoto}
                                        className='btn-gradient take-photo'
                                        disabled={this.state.isPrepare}
                                    >
                                        <Translated id="app.matching.take-photo" />
                                    </button>}
                            </div>
                        </Fade>

                        <Zoom in={this.state.isCompare} timeout={{ enter: 500, exit: 0 }} mountOnEnter unmountOnExit>
                            <div className='compare'>
                                <div className='faces'>
                                    <canvas
                                        ref={this.canvasSampleRef}
                                        width={300}
                                        height={225} />

                                    <canvas
                                        ref={this.canvasClientRef}
                                        width={300}
                                        height={225} />
                                </div>
                            </div>
                        </Zoom>

                        <Slide in={!this.state.isLoading && (this.state.isChoose || this.state.isTakePhoto || this.state.isCompare)} direction={this.props.direction || 'left'} timeout={{ enter: 800, exit: 0 }} mountOnEnter unmountOnExit>
                            <div>
                                <Instruction
                                    isShow={this.state.isChoose || this.state.isTakePhoto}
                                    major={this.state.isChoose
                                        ? this.props.isOnboarding
                                            ? this.props.isDocument
                                                ? "app.matching.choose-title.document"
                                                : "app.matching.choose-title.onboarding"
                                            : "app.matching.choose-title.matching"
                                        : this.state.isTakePhoto
                                            ? this.props.isOnboarding
                                                ? "app.matching.take-title.onboarding"
                                                : "app.matching.take-title.matching"
                                            : null}
                                    minor={this.state.isChoose
                                        ? this.props.isOnboarding
                                            ? null
                                            : "app.matching.choose-text.matching"
                                        : this.state.isTakePhoto
                                            ? this.props.isOnboarding
                                                ? "app.matching.take-text.onboarding"
                                                : "app.matching.take-text.matching"
                                            : null} />

                                {this.state.isCompare && <div className='results'>
                                    <div className='similarity'>
                                        <p><Translated id="app.matching.results" /></p>
                                        <div>
                                            <Translated id="app.matching.max" />: <span style={this.state.maxSimilarity >= 0.7 ? { color: colors.svMatchGreen } :
                                                this.state.maxSimilarity >= 0.5 ? { color: colors.svMatchYellow } : { color: colors.svMatchRed }}>
                                                {this.state.maxSimilarity > 0 ? (this.state.maxSimilarity * 100).toFixed(2) : '0.00'}</span>
                                        </div>

                                        <div>
                                            <Translated id="app.matching.min" />: <span style={this.state.minSimilarity >= 0.7 ? { color: colors.svMatchGreen } :
                                                this.state.minSimilarity >= 0.5 ? { color: colors.svMatchYellow } : { color: colors.svMatchRed }}>
                                                {this.state.minSimilarity > 0 ? (this.state.minSimilarity * 100).toFixed(2) : '0.00'}</span>
                                        </div>

                                        <div>
                                            <Translated id="app.matching.current" />: <span style={this.state.currentSimilarity >= 0.7 ? { color: colors.svMatchGreen } :
                                                this.state.currentSimilarity >= 0.5 ? { color: colors.svMatchYellow } : { color: colors.svMatchRed }}>
                                                {this.state.currentSimilarity > 0 ? (this.state.currentSimilarity * 100).toFixed(2) : '0.00'}</span>
                                        </div>
                                    </div>

                                    <ButtonArrow
                                        text={<Translated id="app.button.finish" />}
                                        onClick={() => this.props.history.push('/feature')} />

                                    <ButtonArrow
                                        text={<Translated id="app.button.again" />}
                                        isArrow={false}
                                        isSmall={true}
                                        onClick={this.state.onRetry} />
                                </div>}
                            </div>
                        </Slide>

                        <Status
                            isShow={this.state.isLoading || this.state.isSuccess || this.state.isError}
                            isLoading={this.state.isLoading}
                            isError={this.state.isError}
                            isSuccess={this.state.isSuccess}
                            isPure={this.state.isPureStatus}
                            onRetry={this.state.onRetry}>
                            {this.state.status}
                        </Status>
                    </div>
                </Slide>
            </div>
        )
    }
}

export default Match
